/* eslint-disable react/prop-types */
import React, { useState } from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import { customStyles } from "./styles";
import styles from "./MultiSelect.scss";
import { DeleteIcon } from "./DeleteIcon";

/**
 * Multi Select dropdown with options , it will show the count of the selected options
 * Based on https://react-select.com/home.
 */

const propTypes = {
  /**
   * Options containing value and label.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.node.isRequired,
      label: PropTypes.node.isRequired,
    })
  ),
  /**
   * Callback for when the option gets changed
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Default and disabled heading option for select
   */
  defaultLabel: PropTypes.string,
  /**
   * disabled for the multi select
   */
  disabled: PropTypes.bool,

  /**
   * show selection unit or no
   */

  showUnit: PropTypes.bool,

  /**
   * Plural Unit
   */
  pluralUnit: PropTypes.string,

  /**
   * singular Unit
   */
  singularUnit: PropTypes.string,

  /**
   * select all label
   */
  selectAll: PropTypes.string,

  /**
   * defaultValue
   */
  defaultValue: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.node.isRequired,
      label: PropTypes.node.isRequired,
    })
  ),
};

const defaultProps = {
  options: [],
  defaultValue: [],
  defaultLabel: "Select",
  showUnit: false,
  disabled: false,
  pluralUnit: "Companies",
  singularUnit: "Company",
  selectAll: "Select all",
};

// Option component override for the react-select Select component (formats the display of the options)
export function Option({ children, ...props }) {
  const { isSelected, label, data, innerProps } = props;
  innerProps.id = data?.id ?? innerProps.id;

  const onClick = (e) => {
    props.selectOption({ ...data });
    e.stopPropagation();
    e.preventDefault();
  };
  return (
    <components.Option {...props}>
      <div
        role="presentation"
        className="multi-select-option"
        onClick={onClick}
      >
        <div className={styles.multiSelectCheck}>
          <span className="fa-fw select-all far">
            {!isSelected ? "" : ""}
          </span>
          <span className="px-2">{label}</span>
        </div>
      </div>
    </components.Option>
  );
}
function MultiSelect(props) {
  const {
    options,
    onChange,
    defaultLabel,
    showUnit,
    pluralUnit,
    singularUnit,
    defaultValue,
    selectAll,
    disabled,
    ...rest
  } = props;

  const [value, setValue] = useState(defaultValue);

  const onSelectChange = (selectedOption, actionMeta) => {
    if (selectedOption.find((option) => option.value === "all")) {
      setValue(options);
      onChange(options);
    } else if (actionMeta.action === "clear") {
      setValue([]);
      onChange([]);
    } else {
      setValue(selectedOption);
      onChange(selectedOption);
    }
  };

  function MultiValueContainer() {
    return null;
  }

  return (
    <div>
      <h3 className={styles.header}>{singularUnit} Selection</h3>

      {value.length > 0 && (
        <div className={styles.wrapper}>
          <div className={styles.counter}>
            {value.length === options.length ? "All" : value.length}
          </div>

          <DeleteIcon
            onClick={() => {
              if (!disabled) {
                setValue([]);
                onChange([]);
              }
            }}
          />
        </div>
      )}

      {showUnit && value.length > 0 && (
        <div
          className={styles.wrapperUnit}
          style={{ marginLeft: value.length > 1 ? 57 : 54 }}
        >
          {value.length > 1 ? pluralUnit : singularUnit}
        </div>
      )}

      <Select
        value={value}
        styles={customStyles}
        disabled={disabled}
        options={
          options.length > value.length
            ? [{ label: selectAll, value: "all" }, ...options]
            : options
        }
        isMulti
        hideSelectedOptions={false}
        isClearable={false}
        closeMenuOnSelect={false}
        onChange={(selectedOption, actionMeta) =>
          !disabled && onSelectChange(selectedOption, actionMeta)
        }
        components={{ MultiValueContainer, Option }}
        placeholder={defaultLabel}
        {...rest}
      />

      <div className={styles.companiesWrapper}>
        <div className={styles.selectedCompany}>
          Selected {pluralUnit.toLowerCase()} : {value.length}
        </div>
      </div>
      <div className={styles.companiesWrapper}>
        {value.length > 0 && value.length === options.length ? (
          <div className={styles.companywrapper}>
            <div className={styles.counter}>All {pluralUnit}</div>

            <DeleteIcon
              onClick={() => {
                if (!disabled) {
                  setValue([]);
                  onChange([]);
                }
              }}
            />
          </div>
        ) : (
          value.map((option) => (
            <div className={styles.companywrapper}>
              <div className={styles.counter}>{option.label}</div>

              <DeleteIcon
                onClick={() => {
                  if (!disabled) {
                    const filteredValues = value.filter(
                      (item) => item !== option
                    );
                    setValue(filteredValues);
                    onChange(filteredValues);
                  }
                }}
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}

MultiSelect.propTypes = propTypes;
MultiSelect.defaultProps = defaultProps;

export default MultiSelect;
